import { TAddressDetailsResponse } from "../models/addressDetails";
import type { TAddressDetails } from "../types";

const mapAddressDetailsResponse = (response: TAddressDetailsResponse): TAddressDetails => ({
  id: response.id,
  city: response.address.city,
  street: response.address.street,
  houseNumber: response.address.houseNumber,
  postalCode: response.address.postalCode,
});

export default mapAddressDetailsResponse;
